<template>
  <div>
    <div id="titleInfo">
      银联支付: 请在弹出的官方付款页面内完成付款
      <span style="cursor: pointer;" @click="jumpToYinLianPageFun"
        >（ 点我重新打开付款页面 ）</span
      >
    </div>
    <div>
      <div v-if="userPayStatus == false">
        <div id="waitInfo">
          正在等待用户付款
          <span class="el-icon-loading"></span>
        </div>
      </div>
      <div v-else id="paySuccessPan" class="el-icon-success">
        支付成功 !
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['checkTradeIntervalAddressEvent'],
  props: {
    scId: Number
  },
  data () {
    return {
      userPayStatus: false,
      intervalAddress: null
    }
  },
  mounted () {
    // 默认初始化后就直接跳到银联支付的页面
    this.jumpToYinLianPageFun()
    clearInterval(this.intervalAddress) // 清除上一个定时器
    // 监听用户是否付款的事件
    this.intervalAddress = setInterval(this.checkUserHasPaiedOrNot, 1000)
    this.$emit('checkTradeIntervalAddressEvent', this.intervalAddress)
  },
  methods: {
    jumpToYinLianPageFun () {
      const yinlianHref =
        '/md/front/shoppingCart/payType/yinlian/jump?shoppingCartsId=' +
        this.scId
      window.open(yinlianHref)
    },
    checkUserHasPaiedOrNot () {
      // 检查一次当前用户是否付款
      const api = '/md/front/shoppingCart/payType/yinlian/checkValidate'
      let params = {
        shoppingCartId: this.scId
      }
      params = this.$qs.stringify(params) // 将json格式的内容转换为拼接的字符串, 发送方式还是post
      const that = this
      this.axios.post(api, params).then(res => {
        if (res.status === 200 && res.data) {
          that.userPayStatus = true // 修改支付状态
          clearInterval(that.intervalAddress) // 清除定时器
          this.$notify('付款成功, 5秒后跳转到账户页面')
          setTimeout(() => {
            this.$router.push('/userCenter/info').catch(() => {})
          }, 5000)
        } else {
          console.log('用户当前未付款')
        }
      })
    }
  }
}
</script>

<style scoped>
#titleInfo {
  height: 100px;
  color: #fff;
  font-size: 20px;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  padding-top: 50px;
}

#waitInfo {
  height: 100px;
  font-size: 20px;
  color: #fff;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  padding-top: 50px;
  padding-bottom: 30px;
}

#titleInfo .el-link.el-link--default {
  color: #ef2014;
  font-size: 16px;
}

#paySuccessPan {
  height: 100px;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  padding-top: 50px;
  padding-bottom: 30px;
  font-size: 22px;
  color: crimson;
}
</style>
